import React, { Component } from 'react';
import { StepPage } from '../../controls/StepPage';
import { CustomizedMachineOtherStepView } from './CustomizedMachineOtherStepView'

export class CustomizedStep4Page extends StepPage {

    constructor(props) {
        super(props);
        //DO not need to show user name
        //let model = props.model;
        //if (!model.fillingPerson) {
        //    var user = authorizeService.getCurrentUser();
        //    if (user) {
        //        model.fillingPerson = user.fullName;
        //    }
        //}
    }
    validate() {
        var result = this.customizedMachineOtherRef.validate();
        if (!result.state) {
            return result;
        }
        return { state: true, msg: "validate success" };
    }
    render() {
        let data = this.props.model;
        if (!data) {
            return null;
        }

        return <div className="w-11/12">
            <CustomizedMachineOtherStepView  leftRightOption={data.leftRightOption} model={data.customizedMachineModelInf} onRef={(ref) => { this.customizedMachineOtherRef = ref }}
                orderModel={data} />
        </div>
    }
}